/**
 * Web-only app navigator. One screen only: Home (admin dashboard with tabs).
 * No FAB on web, so no IssueReport. All other *Screen components are mobile-only.
 */
import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { ForgotPasswordScreen } from '../screens/ForgotPasswordScreen';
import { GenerateProgramScreen } from '../screens/GenerateProgramScreen.web';
import { HomeScreen } from '../screens/HomeScreen';
import { PasswordChangeScreen } from '../screens/PasswordChangeScreen';
import { RequestAccountDeletionScreen } from '../screens/RequestAccountDeletionScreen';
import { useGetMeQuery } from '../services/abbiWayApi';
import { stackHeaderTitleStyle } from '../theme';
const Stack = createNativeStackNavigator();
export const AppNav = () => {
    const { data: me } = useGetMeQuery();
    const isAdmin = me?.role?.name === 'Admin';
    return (<Stack.Navigator initialRouteName="Home" screenOptions={{
            headerShown: true,
            headerBackTitleVisible: false,
            headerTitleStyle: stackHeaderTitleStyle,
        }}>
      <Stack.Screen name="ForgotPassword" component={ForgotPasswordScreen} options={{ title: 'Forgot password', headerShown: true }}/>
      <Stack.Screen name="RequestAccountDeletion" component={RequestAccountDeletionScreen} options={{ title: 'Request account deletion', headerShown: true }}/>
      <Stack.Screen name="PasswordChange" component={PasswordChangeScreen} options={{ title: 'Set new password', headerShown: true }}/>
      <Stack.Screen name="Home" component={HomeScreen} options={{ title: "Abbi's Way" }}/>
      {isAdmin && (<Stack.Screen name="GenerateProgram" component={GenerateProgramScreen} options={{ title: 'Generate program' }}/>)}
    </Stack.Navigator>);
};
